<template>
  <div class="card">
    <div class="card-body">
      <h5 class="fw-500 text-uppercase">Laporan Sales Produk by Type</h5>
      <div class="divider"></div>
      <div class="d-flex align-items-end justify-content-between">
        <div class="d-flex align-items-end">
          <div
            class="form-group me-1"
            v-show="$store.getters['laporanSales/filterOutlet']"
          >
            <label for="exampleFormControlInput30">Outlet</label>
            <input
              style="font-size: 13px"
              type="text"
              class="form-control"
              id="exampleFormControlInput30"
              v-model="search.outlet"
            />
          </div>
          <div class="form-group me-1">
            <label for="exampleFormControlInput30">Tanggal awal</label>
            <input
              style="font-size: 13px"
              type="date"
              class="form-control"
              id="exampleFormControlInput30"
              v-model="search.tglawal"
            />
          </div>
          <div class="form-group me-1">
            <label for="exampleFormControlInput30">Tanggal akhir</label>
            <input
              style="font-size: 13px"
              type="date"
              class="form-control"
              id="exampleFormControlInput30"
              v-model="search.tglakhir"
            />
          </div>
          <div class="form-group me-1">
            <label for="exampleFormControlInput30">by Type</label>
            <select
              style="font-size: 13px"
              class="form-select"
              aria-label="Default select example"
              id="exampleFormControlInput30"
              v-model="search.prodtype"
            >
              <option value="0" selected>Semua</option>
              <option value="1">Non Konsesi</option>
              <option value="3">Konsesi</option>
            </select>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-sm me-1"
            @click="$store.dispatch('laporanSales/showLaporanSalesKonsesi')"
          >
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm me-1"
            @click="$store.dispatch('laporanSales/resetLaporan')"
          >
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>
        </div>
        <div class="text-end">
          <button
            type="button"
            class="btn btn-secondary btn-sm me-1"
            @click="exportExcel"
          >
            <i class="fa fa-file-o icon" aria-hidden="true"></i>
            Excel
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm me-1"
            @click="exportCsv"
          >
            <i class="fa fa-file-o icon" aria-hidden="true"></i>
            Csv
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm me-1"
            @click="print"
          >
            <i class="fa fa-file-o icon" aria-hidden="true"></i>
            Pdf
          </button>
        </div>
      </div>
      <div class="table-responsive mt-2" style="height: 400px; font-size: 12px">
        <table class="table table-hover table-striped table-bordered">
          <thead>
            <tr class="text-center">
              <th style="width: 8%">Outlet</th>
              <th style="width: 8%">Tanggal</th>
              <th style="width: 30%" colspan="2">Nama Produk</th>
              <th style="width: 5%">Type</th>
              <th style="width: 5%">SuppCode</th>
              <th style="width: 10%">Unit Price</th>
              <th style="width: 5%">Qty</th>
              <th style="width: 10%">Gross Sales</th>
              <th style="width: 10%">Total Disc</th>
              <th style="width: 10%">Total Sales</th>
              <th style="width: 5%">Psnco</th>
              <th style="width: 10%">Commis</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(n, index) in datas" :key="index">
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.outlet }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.tgltrx | formatDt2 }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.internal }}</td>
              <td class="text-start" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.descript }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.prodtype }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.suppcode }}</td>
              <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.unitprice | Rupiah2 }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.quantity }}</td>
              <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.grossls | Rupiah2 }}</td>
              <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.ttldisc | Rupiah2 }}</td>
              <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.netsales | Rupiah2 }}</td>
              <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.psnco }}%</td>
              <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.commis | Rupiah2 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-2">
        <table class="table table-hover table-striped table-bordered">
          <thead>
            <tr>
              <th style="width: 40%">Total Sales</th>
              <th class="text-center" style="width: 10%">Total Quantity</th>
              <th class="text-center" style="width: 10%">Total Gross Sales</th>
              <th class="text-center" style="width: 10%">Total Disc</th>
              <th class="text-center" style="width: 10%">Total Commis</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(n, index) in total" :key="index">
              <td class="text-start"></td>
              <td class="text-center">{{ n.TtlQty }}</td>
              <td class="text-end">{{ n.TtlGrossSls | Rupiah2 }}</td>
              <td class="text-end">{{ n.TtlDisc | Rupiah2 }}</td>
              <td class="text-end">{{ n.TtlCommis | Rupiah2 }}</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style="width: 40%">Total Return</th>
              <th class="text-center" style="width: 10%">Total Quantity Return</th>
              <th class="text-center"  style="width: 10%">Total Gross Sales Return</th>
              <th class="text-center" style="width: 10%">Total Disc Return</th>
              <th class="text-center" style="width: 10%">Total Commis Return</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(n, index) in totalReturn" :key="index">
              <td class="text-start"></td>
              <td class="text-center">{{ n.TtlQty }}</td>
              <td class="text-end">{{ n.TtlGrossSls | Rupiah2 }}</td>
              <td class="text-end">{{ n.TtlDisc | Rupiah2 }}</td>
              <td class="text-end">{{ n.TtlCommis | Rupiah2 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-show="show">
        <div class="mt-2" ref="cetak">
          <div style="text-align: center">
            <h5 style="text-transform: uppercase; text-decoration: underline">
              Laporan Sales Produk Konsesi
            </h5>
            <p style="font-size: 12px; margin-top: 5px">
              Priode : {{ search.tglawal ? search.tglawal : "-" }} -
              {{ search.tglakhir ? search.tglakhir : "-" }}
            </p>
          </div>

          <table class="table table-bordered" style="font-size: 12px">
            <thead>
              <tr class="text-center">
                <th style="width: 8%">Outlet</th>
                <th style="width: 8%">Tanggal</th>
                <th style="width: 30%" colspan="2">Nama Produk</th>
                <th style="width: 5%">Type</th>
                <th style="width: 5%">SuppCode</th>
                <th style="width: 10%">Unit Price</th>
                <th style="width: 5%">Qty</th>
                <th style="width: 10%">Gross Sales</th>
                <th style="width: 10%">Total Disc</th>
                <th style="width: 10%">Total Sales</th>
                <th style="width: 5%">Psnco</th>
                <th style="width: 10%">Commis</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(n, index) in datas" :key="index">
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.outlet }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.tgltrx | formatDt2 }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.internal }}</td>
                <td class="text-start" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.descript }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.prodtype }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.suppcode }}</td>
                <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.unitprice | Rupiah2 }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.quantity }}</td>
                <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.grossls | Rupiah2 }}</td>
                <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.ttldisc | Rupiah2 }}</td>
                <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.netsales | Rupiah2 }}</td>
                <td class="text-center" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.psnco }}%</td>
                <td class="text-end" :class="[n.code && n.code === 'return' ? claasReturn : '']">{{ n.commis | Rupiah2 }}</td>
              </tr>
            </tbody>
          </table>
          <div class="mt-2">
            <table class="table table-bordered" style="font-size: 12px">
              <thead>
                <tr>
                  <th style="width: 20%">Total Sales</th>
                  <th class="text-center" style="width: 20%">Total Quantity</th>
                  <th class="text-center" style="width: 20%">Total Gross Sales</th>
                  <th class="text-center" style="width: 20%">Total Disc</th>
                  <th class="text-center" style="width: 20%">Total Commis</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(n, index) in total" :key="index">
                  <td class="text-start"></td>
                  <td class="text-center">{{ n.TtlQty }}</td>
                  <td class="text-end">{{ n.TtlGrossSls | Rupiah2 }}</td>
                  <td class="text-end">{{ n.TtlDisc | Rupiah2 }}</td>
                  <td class="text-end">{{ n.TtlCommis | Rupiah2 }}</td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th style="width: 20%">Total Return</th>
                  <th class="text-center" style="width: 20%">Total Quantity Return</th>
                  <th class="text-center"  style="width: 20%">Total Gross Sales Return</th>
                  <th class="text-center" style="width: 20%">Total Disc Return</th>
                  <th class="text-center" style="width: 20%">Total Commis Return</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(n, index) in totalReturn" :key="index">
                  <td class="text-start"></td>
                  <td class="text-center">{{ n.TtlQty }}</td>
                  <td class="text-end">{{ n.TtlGrossSls | Rupiah2 }}</td>
                  <td class="text-end">{{ n.TtlDisc | Rupiah2 }}</td>
                  <td class="text-end">{{ n.TtlCommis | Rupiah2 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Export from "@/services/Export";
import Print from "@/services/Print";
export default {
  name: "LaporanSalesKonsesiView",
  data() {
    return {
      show: false,
      claasReturn : 'bg-danger bg-gradient text-white',
    };
  },
  computed: {
    datas() {
      return this.$store.state.laporanSales.datas.list;
    },
    total() {
      return this.$store.state.laporanSales.datas.total;
    },
    totalReturn() {
      return this.$store.state.laporanSales.datas.totalReturn;
    },
    search: {
      get() {
        return this.$store.state.laporanSales.search;
      },
      set(value) {
        return this.$store.commit("laporanSales/setSearch", value);
      },
    },
  },
  methods: {
    print() {
      Print.printLaporan(this.$refs.cetak);
    },
    exportCsv() {
      Export.exportCsv(this.datas, "Laporan_Transaksi_By_Produk_Konsesi.csv");
    },
    exportExcel() {
      Export.exportExcels(this.datas, "Laporan_Transaksi_Konsesi");
    },
  },
  created() {
    this.$store.dispatch("laporanSales/resetLaporan");
  },
};
</script>
